import { render, staticRenderFns } from "./ImageScanOrderForm.vue?vue&type=template&id=764a9078&"
import script from "./ImageScanOrderForm.vue?vue&type=script&lang=js&"
export * from "./ImageScanOrderForm.vue?vue&type=script&lang=js&"
import style0 from "./ImageScanOrderForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports